{
    "purchaseOrder": "Bestellung",
    "columns": {
        "columns": "Spalten",
        "name": "Name",
        "requester": "Antragsteller:in ",
        "vendor": "Lieferant",
        "dateOfIssue": "Bestelldatum",
        "createdAt": "Bestelldatum",

        "deliveryStatus": "Lieferstatus",
        "invoicedStatus": "Rechnungsstatus",
        "amount": "Gesamtbetrag",
        "status": "Bestellstatus",
        "action": "Aktionen"
    },
    "list": {
        "title": "Bestellungen",
        "columns": "Spalten"
    },
    "actionButtons": {
        "SUBMIT_FOR_APPROVAL": "Zur Freigabe einreichen",
        "APPROVE": "Freigeben",
        "SUBMIT_FOR_FULFILLMENT": "Bestellung freigeben",
        "CREATE_CARD": "Karte erstellen",
        "CLOSE_PURCHASE_ORDER": "Bestellung abschließen"
    },
    "actionButtonsReject": {
        "SUBMIT_FOR_APPROVAL": "Zurück zu Freigabe",
        "DENY": "Ablehnen"
    },
    "actionButtonsPrevious": {
        "200_SUBMIT_FOR_REDO": "Änderungen anfordern",
        "300_SUBMIT_FOR_REDO": "Zurück zu Freigabe"
    },
    "actionTitles": {
        "100": "Antrag ist ein Entwurf.",
        "200": "Antrag freigeben?",
        "200__not_approver": "Freigabe ausstehend",
        "300": "Überprüfung durch den Einkauf erforderlich.",
        "400": "Warten auf Bestätigung."
    },
    "actionSubtitles": {
        "100": "Überprüfen Sie vor dem Einreichen, ob alle Angaben korrekt sind.",
        "200": "Prüfen Sie, ob die Bestellung ins Budget passt.",
        "200__not_approver": "Der/die Freigebern:in muss den Antrag genehmigen.",
        "300": "Beschaffungsrichtlinien einhalten.",
        "400": "Bestellung als abgeschlossen markieren, sobald alle Artikel geliefert und in Rechnung gestellt sind."
    },
    "rejection_note": {
        "title": "Begründung der Ablehnung",
        "message": "Bitte geben Sie den Grund für die Ablehnung an.",
        "placeholder": "Begründung der Ablehnung",
        "confirm": "Ablehnen",
        "cancel": "Abbrechen"
    },
    "request_changes": {
        "title": "Warnung",
        "message": "Wenn Sie Änderungen an dieser Bestellanfrage anfordern, wird der Genehmigungsprozess zurückgesetzt und alle bereits erteilten Genehmigungen gehen verloren. Möchten Sie fortfahren?",
        "placeholder": "Welche Änderungen möchten Sie anfordern?",
        "confirm": "Ja",
        "cancel": "Nein"
    },
    "deliveryStatus": {
        "short": {
            "fullyDelivered": "geliefert",
            "partiallyDelivered": "teilw. geliefert",
            "notDelivered": "offen",
            "none": "kein"
        },
        "full": {
            "fullyDelivered": "geliefert",
            "partiallyDelivered": "teilweise geliefert",
            "notDelivered": "Lieferung offen",
            "none": "Kein"
        }
    },
    "invoicedStatus": {
        "short": {
            "fullyInvoiced": "berechnet",
            "partiallyInvoiced": "teilw. berechnet",
            "notInvoiced": "keine Rech."
        },
        "full": {
            "fullyInvoiced": "berechnet",
            "partiallyInvoiced": "teilweise berechnet",
            "notInvoiced": "keine Rechnung"
        }
    },
    "details": {
        "title": "Bestellung",
        "vat": "MwSt %",
        "totalVatAmount": "Gesamtbetrag MwSt.",
        "costCenter": "Kostenstelle",
        "costUnit": "Kostenträger",
        "costCenter2": "Kostenträger",
        "quantity": "Menge",
        "quantityReceived": "Menge erhalten",
        "totalNet": "Netto Ges.",
        "totalGross": "Brutto Ges.",
        "totalAmountInvoiced": "Gesamtbetrag in Rechnung gestellt",
        "deliveryNotes": "Lieferscheine",
        "invoices": "Rechnungen",
        "addDeliveryNote": "Lieferschein hinzufügen",
        "addInvoice": "Dokument hinzufügen",
        "orDropFilesToUpload": "oder Dateien hierher ziehen",
        "purchaseOrderDocument": "Bestelldokument",
        "purchaseDetails": "Bestelldetails",
        "comments": "Kommentare",
        "None": "Keine",
        "Complete": "Vollständig",
        "Partial": "Teilweise",
        "totalTax": "Total MwSt."
    },
    "unitOfMeasure": {
        "pcs": "Stück / Stk.",
        "doz": "Dutzend",
        "pr": "Paar",
        "set": "Set",
        "pk": "Packung",
        "bx": "Schachtel / Kiste",
        "bdl": "Bündel",
        "rl": "Rolle",
        "kg": "Kilogramm",
        "g": "Gramm",
        "t": "Tonne",
        "mg": "Milligramm",
        "oz": "Unze",
        "lb": "Pfund",
        "ton": "Tonne",
        "mm": "Millimeter",
        "cm": "Zentimeter",
        "m": "Meter",
        "km": "Kilometer",
        "in": "Zoll",
        "ft": "Fuß",
        "yd": "Yard",
        "mi": "Meile",
        "ml": "Milliliter",
        "l": "Liter",
        "cm3": "Kubikzentimeter",
        "m3": "Kubikmeter",
        "fl_oz": "Flüssigunze",
        "gal": "Gallone",
        "s": "Sekunde",
        "min": "Minute",
        "h": "Stunde",
        "day": "Tag",
        "week": "Woche",
        "month": "Monat",
        "year": "Jahr",
        "j": "Joule",
        "kj": "Kilojoule",
        "cal": "Kalorie",
        "kcal": "Kilokalorie",
        "wh": "Wattstunde",
        "kwh": "Kilowattstunde",
        "w": "Watt",
        "kw": "Kilowatt",
        "hp": "Pferdestärke (PS)",
        "celsius": "Celsius",
        "fahrenheit": "Fahrenheit",
        "kelvin": "Kelvin"
    },
    "drawer": {
        "newPurchaseOrder": "Neue Bestellung",
        "editPurchaseOrder": "Bestellung bearbeiten",
        "poNumber": "Bestellnummer",
        "vendor": "Lieferant",
        "dateOfIssue": "Erstelldatum",
        "description": "Beschreibung",
        "createCard": "Karte erstellen",
        "cardTooltip": "Wenn es es sich bei Ihrer Bestellung um eine Dienstleistung handelt bitte aktivieren.",
        "service": "Dienstleistung",
        "letUsKnowIfYourOrderIsForPhysicalGoodsOrAService": "Wenn es es sich bei Ihrer Bestellung um eine Dienstleistung handelt bitte aktivieren.",
        "addTag": "Tag erstellen",
        "performancePeriod": "Leistungszeitraum",
        "performanceDate": "Leistungsdatum",
        "deliveryDate": "Geplantes Lieferdatum",
        "expenseAccount": "Sachkonto",
        "currency": "Währung",
        "selectCurrency": "Währung auswählen",
        "totalNet": "Netto Ges.",
        "totalVat": "MwSt. Ges.",
        "vat": "MwSt.",
        "totalGross": "Brutto Ges.",
        "lineItems": "Artikel",
        "quantity": "Menge",
        "unit": "Mengeneinheit",
        "unitPrice": "Einzelpreis",
        "taxRate": "MwSt.",
        "materialCode": "Artikel Code",
        "link": "Link",
        "note": "Notiz",
        "addItem": "Artikel hinzufügen",
        "nextApprover": "Nächster Genehmiger",
        "requester": "Anfrager",
        "selectNextApprover": "Nächster Genehmiger auswählen",
        "saveAsDraft": "Entwurf",
        "submitOrder": "Bestellung einreichen",
        "clickToUploadOrDragAndDropFilesHere": "Klicken Sie hier um Dateien hochzuladen oder hierher zu ziehen",
        "supportsPdfImagesAndOtherDocumentFormats": "Unterstützt PDF, Bilder und andere Dokumentformate",
        "view": "Vorschau",
        "edit": "Bearbeiten",
        "delete": "Löschen",
        "updateOrder": "Bestellung aktualisieren",
        "costCenter2": "Kostenträger",
        "selectRequester": "Anfrager auswählen",

        "addNote": "Notiz hinzufügen",
        "addUrlLink": "URL Link hinzufügen",

        "startDate": "Startdatum",
        "endDate": "Enddatum",

        "expectedServiceDate": "Leistungsdatum",
        "expectedDeliveryDate": "Erwartetes Lieferdatum"
    },
    "lineItemCard": {
        "pleaseEnterMaterialCode": "Bitte geben Sie eine Materialnummer ein",
        "pleaseEnterDescription": "Bitte geben Sie eine Beschreibung ein",
        "pleaseEnterQuantity": "Bitte geben Sie eine Menge ein",
        "pleaseSelectUoM": "Bitte wählen Sie eine Mengeneinheit",
        "pleaseEnterUnitPrice": "Bitte geben Sie einen Einzelpreis ein",
        "pleaseSelectTaxRate": "Bitte wählen Sie eine MwSt. Rate",
        "pleaseSelectCostCenter": "Bitte wählen Sie eine Kostenstelle",
        "pleaseSelectCostUnit": "Bitte wählen Sie einen Kostenträger",
        "pleaseSelectExpenseAccount": "Please select an expense account",
        "pleaseEnterLink": "Please enter a link",
        "pleaseEnterNote": "Please enter a note",
        "totalNetAmountCannotBe0": "Nettobetrag kann nicht 0 sein",
        "totalGrossAmountCannotBe0": "Bruttobetrag kann nicht 0 sein",
        "pleaseEnterTotalVat": "Bitte geben Sie einen Gesamtbetrag für die MwSt. ein",
        "enableOcr": "OCR aktivieren",
        "removeFile": "Datei entfernen",
        "clickToUploadOrDragAndDropFilesHere": "Klicken Sie hier um Dateien hochzuladen oder hierher zu ziehen",
        "supportsPdfImagesAndOtherDocumentFormats": "Unterstützt PDF, Bilder und andere Dokumentformate",
        "view": "Ansehen",
        "materialCode": "Artikel Code",
        "description": "Artikel"
    },
    "optionButtons": {
        "view": "Ansehen",
        "edit": "Bearbeiten",
        "delete": "Löschen"
    },
    "delivery_location": {
        "loading": "Adresse eintippen, wir suchen für Sie..."
    },
    "linked_to_this_po": "Mit dieser Bestellung verknüpft"
}
